import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import centralApiAxios from "../../axios/centralApiAxios";

import {
    UPDATE_CONTACTBLOCK,
    GET_CONTACTBLOCK_LIST,
    GET_CONTACTBLOCK,
    GET_ORDER_CONTACTBLOCK,
    UPDATE_ORDER_CONTACTBLOCK,
    CREATE_CONTACTBLOCK,
    SAVE_CONTACTBLOCK,
    DELETE_CONTACTBLOCK
} from '../actions';

import {
    updateContactBlockSuccess,
    updateContactBlockError,
    getContactBlockListSuccess,
    getContactBlockListError,
    getContactBlockSuccess,
    getContactBlockError,
    getOrderContactBlockSuccess,
    getOrderContactBlockError,
    updateOrderContactBlockSuccess,
    updateOrderContactBlockError,
    createContactBlockSuccess,
    createContactBlockError,
    saveContactBlockSuccess,
    saveContactBlockError,
    trashContactBlockSuccess,
    trashContactBlockError
} from './actions';
import { getActivityHeadersUpdated } from '../../utils/parentChildActivities';

export function* watchSaveContactBlock() {
    yield takeEvery(SAVE_CONTACTBLOCK, saveContactBlock);
}


export function* watchCreateContactBlock() {
    yield takeEvery(CREATE_CONTACTBLOCK, createContactBlock);
}

export function* watchUpdateOrderContactBlock() {
    yield takeEvery(UPDATE_ORDER_CONTACTBLOCK, updateOrderContactBlock);
}

export function* watchUpdateContactBlock() {
    yield takeEvery(UPDATE_CONTACTBLOCK, updateContactBlock);
}

export function* watchGetContactBlockList() {
    yield takeEvery(GET_CONTACTBLOCK_LIST, getContactBlockList);
}

export function* watchGetContactBlock() {
    yield takeEvery(GET_CONTACTBLOCK, getContactBlock);
}

export function* watchGetOrderContactBlock() {
    yield takeEvery(GET_ORDER_CONTACTBLOCK, getOrderContactBlock);
}

const updateOrderContactBlockAsync = async (payload) => {

    try {

        let responseObject = await centralApiAxios.put("contact_blocks?id=" + payload.contactBlock.contactBlockId, payload.contactBlock, getActivityHeadersUpdated(payload));

        return {
            orderContactBlock: payload.contactBlock,
            message: null,
        }
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}

const updateContactBlockAsync = async (payload) => {

    //console.log("update contactblock");
    try {

        //contactBlock put 
        // eslint-disable-next-line 
        let responseObject = await centralApiAxios.put("contact_blocks?id=" + payload.contactBlock.contactBlockId, payload.contactBlock, getActivityHeadersUpdated(payload));

        return {
            contactBlock: payload.contactBlock,
            message: null,
        }
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}

const createContactBlockAsync = async (payload) => {

    try {
        let responseObject = await centralApiAxios.post("contact_blocks", payload.cb);

        return {
            contactBlock: responseObject.data,
            message: null,
        }
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}


const saveContactBlockAsync = async (payload) => {
    //console.log("save contactblock contactblockId: "+payload.cb.contactBlockId);

    try {

        if (payload.cb.contactBlockId > 0) {
            let responseObject = await centralApiAxios.put("contact_blocks?id=" + payload.cb.contactBlockId, payload.cb, getActivityHeadersUpdated(payload));


            return {
                savedcontactBlock: responseObject.data,
                message: null,
            }
        }
        else {
            let responseObject = await centralApiAxios.post("contact_blocks", payload.cb);
            return {
                savedcontactBlock: responseObject.data,
                message: null,
            }
        }

    } catch (error) {
        //console.log(error);
        return {
            savedcontactBlock: null,
            message: 'Failed to get. ' + error
        }
    }
}

const getContactBlockListAsync = async (payload) => {

    let responseObject = await centralApiAxios.get("contact_blocks?contact_id=" + payload.contactId + "&record_state=" + payload.recordState + "&record_type=" + payload.recordType + "&trashed=false", getActivityHeadersUpdated(payload));
    let sortcontactblocklist = responseObject.data.items.sort((a, b) => b.contactBlockId - a.contactBlockId);
    try {

        return {
            contactBlockList: sortcontactblocklist,
            message: null,
        }
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}

const getContactBlockAsync = async (payload) => {
    try {
        let responseObject = await centralApiAxios.get("contact_blocks/" + payload.contactBLockId, getActivityHeadersUpdated(payload));

        return {
            contactBlock: responseObject.data,
            message: null,
        }
    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}

const getOrderContactBlockAsync = async (payload) => {
    try {
        if (payload.contactBLockId > 0) {
            let responseObject = await centralApiAxios.get("contact_blocks/" + payload.contactBLockId, getActivityHeadersUpdated(payload));

            return {
                orderContactBlock: responseObject.data,
                message: null,
            }
        }
        else {
            return {
                contact: null,
                message: 'Failed to get contactblock. '
            }
        }

    } catch (error) {
        return {
            contact: null,
            message: 'Failed to get contact. ' + error
        }
    }
}


function* saveContactBlock({ payload }) {
    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("save contact block");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const returnedData = yield call(saveContactBlockAsync, payload);
            if (!returnedData.message) {
                yield put(saveContactBlockSuccess(returnedData.savedcontactBlock));
            } else {
                yield put(saveContactBlockError(returnedData.message));
            }
        } catch (error) {
            yield put(saveContactBlockError(error));
        }
    }
}

function* createContactBlock({ payload }) {
    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("create contact block");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const returnedData = yield call(createContactBlockAsync, payload);
            if (!returnedData.message) {
                yield put(createContactBlockSuccess(returnedData.contactBlock));
            } else {
                yield put(createContactBlockError(returnedData.message));
            }
        } catch (error) {
            yield put(createContactBlockError(error));
        }
    }
}

function* updateOrderContactBlock({ payload }) {
    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("update order contactblock");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const returnedData = yield call(updateOrderContactBlockAsync, payload);
            if (!returnedData.message) {
                yield put(updateOrderContactBlockSuccess(returnedData.orderContactBlock));
            } else {
                yield put(updateOrderContactBlockError(returnedData.message));
            }
        } catch (error) {
            yield put(updateOrderContactBlockError(error));
        }
    }
}


function* updateContactBlock({ payload }) {
    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("update contactblock");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const returnedData = yield call(updateContactBlockAsync, payload);
            if (!returnedData.message) {
                yield put(updateContactBlockSuccess(returnedData.contactBlock));
            } else {
                yield put(updateContactBlockError(returnedData.message));
            }
        } catch (error) {
            yield put(updateContactBlockError(error));
        }
    }

}

function* getContactBlockList({ payload }) {

    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("get shipping contactblock list");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const returnedData = yield call(getContactBlockListAsync, payload);
            if (!returnedData.message) {
                yield put(getContactBlockListSuccess(returnedData.contactBlockList));
            } else {
                yield put(getContactBlockListError(returnedData.message));
            }
        } catch (error) {
            yield put(getContactBlockListError(error));
        }
    }
}


function* getOrderContactBlock({ payload }) {
    try {
        const returnedData = yield call(getOrderContactBlockAsync, payload);
        if (!returnedData.message) {
            yield put(getOrderContactBlockSuccess(returnedData.orderContactBlock));
        } else {
            yield put(getOrderContactBlockError(returnedData.message));
        }
    } catch (error) {
        yield put(getContactBlockError(error));
    }
}

function* getContactBlock({ payload }) {
    try {
        const returnedData = yield call(getContactBlockAsync, payload);
        if (!returnedData.message) {
            yield put(getContactBlockSuccess(returnedData.contactBlock));
        } else {
            yield put(getContactBlockError(returnedData.message));
        }
    } catch (error) {
        yield put(getContactBlockError(error));
    }
}
export function* watchDeleteContactBlockRecords() {
    yield takeEvery(DELETE_CONTACTBLOCK, deleteContactBlockRecord);
}

const deleteContactBlockRecordAsync = async (payload) => {
    try {
        let responseObject = await centralApiAxios.delete("contact_blocks?trash=true&id=" + payload.contactBlock.contactBlockId, getActivityHeadersUpdated(payload));
        return {
            deletedContactBlock: { ...payload.contactBlock, trashed: true },
            message: null
        };
    } catch (error) {
        return {
            message: 'Failed to delete line item. ' + error
        }
    }
}
function* deleteContactBlockRecord({ payload }) {
    if (payload.isSagaExecuted) {
        yield put(getContactBlockListError("saga called"));
    }
    else {
        //console.log("delete contact block");

        if (!payload.isSagaExecuted) {
            payload.isSagaExecuted = true;
        }

        try {
            const recordListReturned = yield call(deleteContactBlockRecordAsync, payload);
            if (!recordListReturned.message) {
                yield put(trashContactBlockSuccess(recordListReturned.deletedContactBlock));
            } else {
                yield put(trashContactBlockError(recordListReturned.message));
            }
        } catch (error) {
            yield put(trashContactBlockError(error));
        }
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchUpdateContactBlock),
        fork(watchGetContactBlockList),
        fork(watchGetContactBlock),
        fork(watchGetOrderContactBlock),
        fork(watchUpdateOrderContactBlock),
        fork(watchCreateContactBlock),
        fork(watchSaveContactBlock),
        fork(watchDeleteContactBlockRecords),
    ]);
}